import { useGetOrgByIdQuery } from '@/store/slices/api/organizationApiSlice';
import { useGetPatientQuery } from '@/store/slices/api/patientsApiSlice';
import {
  AppointmentApiType,
  appointmentSettingsStatus,
  clinicEriDays,
  clinicHeartFailureDays,
  clinicRoutineDays,
  resolveAppointmentFrequency
} from '@/utils/appointmentFrequency';

export const APPOINTMENT_SETTINGS_ERROR =
  'Clinic and patient schedule settings did not load, so this appointment was not created.';

/** Patient cycle when it is set, otherwise the clinic frequency for this device. */
export function useAppointmentFrequency(patientId?: string) {
  const patientQuery = useGetPatientQuery(patientId ?? '', { skip: !patientId });
  const clinicId = patientQuery.data?.clinic?.id ?? '';
  const orgQuery = useGetOrgByIdQuery(clinicId, { skip: !clinicId });
  const organization = orgQuery.data?.organization;
  const patient = patientQuery.data;
  const { ready, failed } = appointmentSettingsStatus({
    hasPatientId: Boolean(patientId),
    patientSuccess: patientQuery.isSuccess,
    patientError: patientQuery.isError,
    hasClinicId: Boolean(clinicId),
    clinicSuccess: orgQuery.isSuccess,
    clinicError: orgQuery.isError
  });

  const frequencyFor = (
    type: AppointmentApiType,
    deviceType?: string | null,
    enteredFrequency?: number | null
  ) =>
    resolveAppointmentFrequency({
      type,
      deviceType,
      patientCycleIcdPm: patient?.settings?.cycleIcdPm,
      patientCycleHf: patient?.settings?.cycleHf,
      patientCycleIlr: patient?.settings?.cycleIlr,
      clinicRoutineDays: clinicRoutineDays(organization, deviceType),
      clinicHfDays: clinicHeartFailureDays(organization),
      clinicEriDays: clinicEriDays(organization),
      enteredFrequency
    });

  return { ready, failed, frequencyFor };
}
